import styles from './BookkeepingManagerTableTotal.module.css'

export interface BookkeepingManagerTableTotalProps {
  total: number
}

export function BookkeepingManagerTableTotal({
  total,
}: BookkeepingManagerTableTotalProps) {
  return (
    <div className={styles.root}>
      Accounts
      <span className={styles.total}>({total})</span>
    </div>
  )
}
